const wait = (seconds) => (new Promise(resolve => setTimeout(resolve, seconds * 1000)));

export { wait };
//# sourceMappingURL=wait.js.map
